import type { FC, ComponentType } from 'react';
import { type Props as IconWrapProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import OrdersSectionTitle from '../OrdersSectionTitle';

import s from './OrdersByStatusEmptyState.scss';

export interface Props {
  headerTitle: string;
  headerIcon: ComponentType<IconWrapProps>;
  text: string;
}

const OrdersByStatusEmptyState: FC<Props> = ({ headerTitle, headerIcon: HeaderIcon, text }) => {
  return (
    <section className={s['section']}>
      <OrdersSectionTitle title={headerTitle} icon={HeaderIcon} />
      <div className={s['empty-state']}>{text}</div>
    </section>
  );
};

OrdersByStatusEmptyState.displayName = 'OrdersByStatusEmptyState';

export default OrdersByStatusEmptyState;
